import Vue from 'vue'
import * as uiv from 'uiv'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'
import VueScrollTo from 'vue-scrollto'
import moment from 'moment'

Vue.use(uiv)
Vue.use(VueResource)
Vue.use(VueRouter)
Vue.use(VueScrollTo)

//Gobal filter functions
Vue.filter('formatDateTime', function(date, format) {
    if (!date) return moment().format(format);
    else return moment(date).format(format);
  });

Vue.filter('capitalize', function(value) {
    var capitalized = '';
    if (value) {
        var str = value.toLowerCase().split(' ');

        for(var i = 0; i < str.length; i++) {
            str[i] = str[i].split('');
            str[i][0] = str[i][0].toUpperCase();
            str[i] = str[i].join('');
        }

        capitalized =  str.join(' ')
     }
     return capitalized;
 });

Vue.filter('truncate', function(value) {
    let MAX_CHAR = 150;
    if (value == null || value == undefined)
      return "";
    return value.length > MAX_CHAR? value.substring(0, MAX_CHAR) + '...' : value;
  });

 Vue.filter('percentage', function(value, decimals) {
    if(!value)  value = 0;
    if(!decimals) decimals = 0;

    value = value * 100;
    value = Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
    return value + '%';
  });

import App from './App.vue'
import store from './store'
import routes from './routes'
import config from 'config';
import { Notification } from 'uiv'

if(localStorage.token)
  {
    console.log("ah suh")
    localStorage.token = config.appToken;
    localStorage.setItem('token', localStorage.token)
  
  } else {
      console.log("i am here");
      localStorage.clear();
      localStorage.token = config.appToken;
      localStorage.setItem('token', localStorage.token)
    }
const router = new VueRouter(routes);

router.beforeEach((to, from, next) => {
  // ...
  bus.$emit('show-full-loading');
  next();

})

router.afterEach((to, from) => {
  // ...
  bus.$emit('hide-full-loading');

})


export const bus = new Vue();

function showNotification (data) {
    let hasHTMLContent = data.hasOwnProperty('html');
    if (hasHTMLContent){
      let notif = Notification.notify({
        type: data.type,
        title: data.title,
        content: data.content,
        html: hasHTMLContent,
        duration: 0,
      }).then(() => {
        console.log("dismiss");
      }) 
    } else {
      let notif = Notification.notify({
        type: data.type,
        title: data.title,
        content: data.content,
        duration: 2000,
      }).then(() => {
        console.log("dismiss")
      })
    }
}

function showMessageBox (data) {
  Notification.$alert({
    title: item.data.title,
    content: item.data.content
  });
}

bus.$on('notification', (item) => {
  showNotification(item.data);
})
  
// listen for the message box event on the eventHub (main)
bus.$on('message-box', (item) => {
  showMessageBox(item.data);
})


const vm = new Vue({
  el: '#app',
  store,
  router,
  render: h => h(App)
});

window.vm = vm;



// WEBPACK FOOTER //
// ./src/main.js